/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { concatDependencies } from './dependenciesConcat.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createTo } from '../../factoriesAny.js';
export var toDependencies = {
  concatDependencies,
  matrixDependencies,
  typedDependencies,
  createTo
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesTo.generated.js
// module id = 57ha
// module chunks = 3